"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteError = void 0;
exports.QuoteError = {
    FAILED_TO_FETCH_RATES: 'FAILED_TO_FETCH_RATES',
    INVALID_DESTINATION_ADDRESS: 'INVALID_DESTINATION_ADDRESS',
    INVALID_ORIGIN_ADDRESS: 'INVALID_ORIGIN_ADDRESS',
    INVALID_LTL_REQUEST: 'INVALID_LTL_REQUEST',
    INVALID_SERVICE_TYPE: 'INVALID_SERVICE_TYPE',
    INVALID_ZIP_CODE: 'INVALID_ZIP_CODE',
    UNSUPPORTED_PICKUP_OR_DELIVERY_LOCATION: 'UNSUPPORTED_PICKUP_OR_DELIVERY_LOCATION',
    NO_ACCESS_FOR_GIVEN_ID: 'NO_ACCESS_FOR_GIVEN_ID',
    NO_QUOTE_FOR_GIVEN_ID: 'NO_QUOTE_FOR_GIVEN_ID',
    FAILED_TO_FETCH_LATLNG: 'FAILED_TO_FETCH_LATLNG',
    MIXED_SERVICE_REQUEST_TYPES_UNSUPPORTED: 'MIXED_SERVICE_REQUEST_TYPES_UNSUPPORTED '
};
//# sourceMappingURL=quote-error.js.map